// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__FxRyg","ranges":"BmiRanges_ranges__1gC95"};